import EditURNModal from './EditURNModal'
export default EditURNModal
